import React from 'react';

import { Donor } from 'src/commons/types';

export const CurrentDonorInViewContext = React.createContext<Donor | null>(
  null
);
